// extracted by mini-css-extract-plugin
export default {"container":"RFADB6","thumbnail-wrapper":"hay2eW","thumbnailWrapper":"hay2eW","prev-button":"CjvvlN","prevButton":"CjvvlN","next-button":"sS_ECt","nextButton":"sS_ECt"};